<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <filtro-categoria (seleccion)="cambioCategoria($event)" (seleccionPeriodo)="cambioPeriodo($event)"
                (busqueda)="cambioBusqueda($event)" [filtroPeriodo]="periodosActivos"
                [seleccionado]="periodoId"></filtro-categoria>
        </div>
    </div>
    <div class="row conatinerCategorias">
        <div class="col-12">
            <nominacion-carrusel titulo="Nominados" [grid]="true" [categoriaId]="categoriaId" [periodoId]="periodoId"
                [busqueda]="busqueda" [buscarPeriodo]="periodosActivos"
                [ultimoPeriodo]="ultimoPeriodo"></nominacion-carrusel>
        </div>
    </div>
</div>